module.exports = __webpack_public_path__ + "static/media/pdf-svgrepo-com.bd1d4e36.svg";